import React from 'react';

function EmployeeItem(props) {

    const employee = props.data;
    
    return(
        <li className="list__item item--employee">
            
            <figure className="item__image">
                <picture>
                    <source srcSet={employee.custom_data.image.webp} type="image/webp" />
                    <source srcSet={employee.custom_data.image.jpeg} type="image/jpeg" />

                    <img loading="lazy" src={employee.custom_data.image.jpeg} alt={employee.title.rendered} width="640" height="720" />
                </picture>                
            </figure>

            <figcaption className="item__meta">
                {employee.title.rendered}
            </figcaption>

        </li>         
    )
}

export default EmployeeItem;
